import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { select } from "@/interface/dataInterface";
import { FC, useEffect } from "react";
import { useGetList } from "react-admin";

const SelectFinal: FC<select> = ({
  id,
  value,
  setValue,
  resource,
  dataProp,
  required,
  placeholder = "Select"
}) => {
  const { data = [] } = useGetList(resource, {
    pagination: { page: 1, perPage: 1000 },
  });

  const handleChange = (selected: string) => {
    const fakeEvent = {
      currentTarget: {
        id,
        value: selected,
      },
    };

    setValue(fakeEvent);
  };

  if (data.length === 0) return;

  return (
    <div className="relative">
      <Select value={value} onValueChange={handleChange}>
        <SelectTrigger className="mt-1 w-full" id={id} name={id}>
          <SelectValue placeholder={placeholder}>
            {data?.find((item) => item.id == value)?.[dataProp] || placeholder}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>Select</SelectLabel>
            <div className="max-h-80 overflow-y-auto">
              {data &&
                data.length > 0 &&
                data?.map((item) => {
                  return (
                    <SelectItem
                      className="text-foreground"
                      key={item.id}
                      value={item.id}
                    >
                      {item[dataProp]}
                    </SelectItem>
                  );
                })}
            </div>
          </SelectGroup>
        </SelectContent>
      </Select>
      <input
        id={id}
        name={id}
        type="text"
        value={value || ""}
        onChange={() => {}}
        required={required || false}
        className="absolute w-px h-px -m-px p-0 overflow-hidden clip-rect-0 border-0 visibility-"
      />
    </div>
  );
};

export default SelectFinal;
